<!-- 返却のダイアログ -->
<template>
  <div>
    <ItemDialog ref="DialogBookRestoreAlert" imageType="alert">
      <template v-slot:content-area>
        <p>
          「OK」を押すと即座に返却されます。<br />
          返却はキャンセルできませんのでご注意ください。
        </p>
      </template>
      <template v-slot:button-area>
        <ItemButton label="OK" actionType="btn-primary" @clicked="putRestore" />

        <ItemButton
          label="キャンセル"
          actionType="btn-cancel"
          @clicked="closeDialog"
        />
      </template>
    </ItemDialog>

    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />
  </div>
</template>

<script>
import API from "@/API";
import { onMounted, computed, watchEffect, ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";

export default {
  name: "DialogBookRestoreAlert",
  components: {
    DialogLoading: DialogLoading,
  },
  props: {
    bookId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const DialogLoading = ref(null);
    const DialogBookRestoreAlert = ref(null);

    const openDialog = () => {
      DialogBookRestoreAlert.value.open();
    };

    const closeDialog = () => {
      DialogBookRestoreAlert.value.close();
    };

    // 譲渡されたbookを返却する
    const putRestore = async () => {
      closeDialog();
      DialogLoading.value.openDialog();

      await API.putRestore(props.bookId);

      DialogLoading.value.closeDialog();
      nativeHandlerService.returnNativeAppMyticketPage();
    };

    return {
      putRestore,
      DialogLoading,
      DialogBookRestoreAlert,
      openDialog,
      closeDialog,
    };
  },
};
</script>
